'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('loginService', function($q, userStore, otppConstants, apiEndpointFactory, userService,
  adobeAnalyticsService, sessionService, urlService, dispatcher, $rootScope, $injector) {

  var $state = $injector.get('$state');
  var $stateParams = $injector.get('$stateParams');

  let progress = 0;

  var loginEndpoint = apiEndpointFactory.new({
    endpointUrl: '/login',
    allowedMethods: ['post'],
    authRequired: true
  });

  var $cookies = angular.injector(['ngCookies']).get('$cookies');

  var service = {
    login: function() {
      userService.clearLoggedOut();
      return loginEndpoint.post().then(function(response) {
        var data = response.data;
        var currentUser = userStore.getAccountHash();
        if (currentUser && currentUser !== data.accountHash) {
          dispatcher.dispatch('user:removeCurrentUser');
          var token = sessionService.getToken();
          if (token) {
            sessionService.clearToken();
            service.logout(token);
          }
        }
        //service.saveLoginData(data.token);
        return data;
      });
    },
    saveLoginData: function(token) {
      sessionService.setToken(token);
    },
    doLogin: function() {
      sessionStorage.setItem('loginLoading', 'true');
      return service.login()
      .catch(function(response) {
        return service.failedLogin(response);
      }).then(function() {
        progress = 0;
        //Dispatch event for Stencil JS components
        window.dispatchEvent(new CustomEvent('update-callback-progress', {'detail': progress += 10}));
        return userService.getAccountInformation();
      }).then(function(session) {
          //Dispatch event for Stencil JS components
        window.dispatchEvent(new CustomEvent('update-callback-progress', {'detail': progress += 10}));
        sessionStorage.setItem('mbr.irn', session.account);
        userService.setCurrentUserAccount({
          irn: session.account,
          accountHash: session.accountHash
        });
        // This event is used in the HeaderCtrl
        $rootScope.$broadcast('otppLogin.loginSuccess');
        service.successfulLogin(session.account);
      });
    },

    successfulLogin: function(account) {
      // DMWS-1689 arbitrarily increase loading progress
      const intervalID = setInterval(() => {
        const interval = 3;
        progress =  progress + interval >= 100 - interval ? progress : progress + interval;
        window.dispatchEvent(new CustomEvent('update-callback-progress', {'detail': progress}));
      }, 2000);

      userService.onLogin(account)
      .then(function(userDetails) {
        clearInterval(intervalID);
        window.dispatchEvent(new CustomEvent('update-callback-progress', {'detail': 100}));
        adobeAnalyticsService.trackLoginEvent();
        sessionStorage.removeItem('loginLoading');
        const isNonMemberSurvivor = userDetails.pensionStatus.nonMemberSurvivor
        if (isNonMemberSurvivor && !service.shouldDeeplink()) {
          urlService.pageRedirect('p.pension');
        }
        else {
          urlService.pageRedirect($cookies.get(otppConstants.authCallbackDestinationKey));
        }
      })
      .catch(function(reason) {
        // case where userService.onLogin errors out
        if (reason !== 'LoginInterrupted') {
          $state.go('home', {err: '502'});
        }
      });
    },

    shouldDeeplink: function() {
      return $cookies.get(otppConstants.authCallbackDestinationKey).split('&')[0] !== 'home';
    },
  
    failedLogin: function(response) {
      if (response.status.toString().charAt(0) === '5') {
        adobeAnalyticsService.trackTechnicalDifficulties();
      } else {
        adobeAnalyticsService.trackFailedLoginEvent();
      }
      sessionStorage.removeItem('loginLoading');

      //setErrorMessage(errorResponseHandler.parseErrorResponse(response));

      //Dispatch event for Stencil JS components
      // window.dispatchEvent(new CustomEvent('login-failed', {'detail': errorResponseHandler.parseErrorResponse(response)}));
      return $q.reject(response);
    },

  };
  return service;
});

